import { UserRole } from './enums';

export const WorkOrderType = Object.freeze({
  GUEST_IMPACT: 'GUEST_IMPACT',
  PROPERTY_CARE: 'PROPERTY_CARE',
  HOUSEKEEPING: 'HOUSEKEEPING',
  FEEDBACK: 'FEEDBACK',
});

export const WORK_ORDER_TYPE_OPTIONS = [
  {
    value: WorkOrderType.GUEST_IMPACT,
    label: 'Standard Work Order',
    shortLabel: 'Standard Work Order',
    description: 'Affects the guest experience and should be resolved during the current stay or before the next arrival. Mark urgent below if this work order is urgent.',
    routingLabel: 'Property Management & Maintenance',
    assignedRoles: [UserRole.PROPERTY_MANAGER, UserRole.MAINTENANCE],
    color: 'blue',
  },
  {
    value: WorkOrderType.PROPERTY_CARE,
    label: 'Property Care - Non-Urgent',
    shortLabel: 'Property Care',
    description: 'Minor maintenance, cosmetic, or preventative work that does not significantly affect a guest’s stay.',
    routingLabel: 'Property Management · Automatically assigned to this property’s manager',
    assignedRoles: [UserRole.PROPERTY_MANAGER, UserRole.MAINTENANCE],
    color: 'amber',
  },
  {
    value: WorkOrderType.HOUSEKEEPING,
    label: 'Housekeeping',
    shortLabel: 'Housekeeping',
    description: 'Cleaning or re-cleaning needs, including linens, bedding, towels, and related concerns.',
    routingLabel: 'Housekeeping',
    assignedRoles: [UserRole.HOUSEKEEPER_MANAGER],
    color: 'emerald',
  },
  {
    value: WorkOrderType.FEEDBACK,
    label: 'Guest / Owner Feedback',
    shortLabel: 'Feedback',
    description: 'Guest or owner feedback that should be documented and tracked separately from the operational queue.',
    routingLabel: 'Property Management · Automatically assigned to this property’s manager · Tracked in the Feedback list',
    assignedRoles: [UserRole.PROPERTY_MANAGER],
    color: 'purple',
  },
];

export const getWorkOrderTypeOption = (value) =>
  WORK_ORDER_TYPE_OPTIONS.find(option => option.value === value) || WORK_ORDER_TYPE_OPTIONS[0];

// Types the backend always assigns to the property's designated manager, so the
// form does not offer a manual assignee for them.
const PROPERTY_MANAGER_ASSIGNED_TYPES = [WorkOrderType.PROPERTY_CARE, WorkOrderType.FEEDBACK];

export const isPropertyManagerAssignedType = (workOrderType) =>
  PROPERTY_MANAGER_ASSIGNED_TYPES.includes(workOrderType);

export const getAssignableTeamDepartment = (workOrderType) =>
  workOrderType === WorkOrderType.HOUSEKEEPING ? 'HOUSEKEEPING' : 'PROPERTY_MANAGEMENT';

// Work order types that are not applicable to a role and are therefore hidden
// from that role's type selector.
const HIDDEN_WORK_ORDER_TYPES_BY_ROLE = Object.freeze({
  [UserRole.INSPECTOR]: [WorkOrderType.FEEDBACK],
});

export const getWorkOrderTypeOptionsForRole = (role) => {
  const hiddenTypes = HIDDEN_WORK_ORDER_TYPES_BY_ROLE[role];
  if (!hiddenTypes) return WORK_ORDER_TYPE_OPTIONS;
  return WORK_ORDER_TYPE_OPTIONS.filter(option => !hiddenTypes.includes(option.value));
};

export const getLegacyWorkOrderType = (data = {}) => {
  if (data.workOrderType) return data.workOrderType;
  if (data.isFeedback) return WorkOrderType.FEEDBACK;
  const roles = data.assignedRoles || [];
  if (roles.includes(UserRole.HOUSEKEEPER_MANAGER)
    && !roles.includes(UserRole.PROPERTY_MANAGER)
    && !roles.includes(UserRole.MAINTENANCE)) {
    return WorkOrderType.HOUSEKEEPING;
  }
  if (roles.includes(UserRole.PROPERTY_MANAGER) || roles.includes(UserRole.MAINTENANCE)) {
    return WorkOrderType.GUEST_IMPACT;
  }
  return '';
};
